import React, { useState, useRef, useEffect } from 'react';
import IconButton from '@/ctComponents/IconButton';
import CustomCheckbox from '@/components/CustomCheckbox';
import { changeNotifications, SaveApiResMessage } from '@/actions';
import { useNotify } from 'react-admin';
import { useSelector } from 'react-redux';

const NotificationSettings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [settings, setSettings] = useState({
    email: false,
    sms: false,
    whatsapp: false,
  });
  const [loading, setLoading] = useState(false);
  const popperRef = useRef(null);
  const buttonRef = useRef(null);
  // const notify = useNotify();

  const user = useSelector((state) => state.reducer.user);

  useEffect(() => {
    if (user && user.notification) setSettings(user.notification);
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSettingChange = (type) => {
    const newValue = !settings[type];
    const newSettings = {
      ...settings,
      [type]: newValue,
    };

    setSettings(newSettings);
    setLoading(true);

    changeNotifications(newSettings)
      .then((res) => {
        setSettings(res.notification || newSettings);
        setLoading(false);
        // notify('Notifications Successfully Updated!', 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Notifications Successfully Updated!',
          mode: 'success',
        });
      })
      .catch((err) => {
        setSettings(settings); // Revert on error
        setLoading(false);
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  return (
    <div className="relative inline-block">
      <div ref={buttonRef}>
        <IconButton
          icon="setting"
          text="Notification Setting"
          color="#131617"
          style={{ padding: '9px 16px', fontSize: '14px', fontWeight: 700 }}
          size="big"
          onClick={handleToggle}
        />
      </div>

      {isOpen && (
        <div
          ref={popperRef}
          className="z-9999 absolute top-full right-0 mt-2 w-187 bg-white border-solid border border-border-tertiary rounded-md shadow-lg ">
          <div className="px-4 py-2">
            <CustomCheckbox
              checked={settings.email}
              onChange={() => handleSettingChange('email')}
              disabled={true}
              label="Email"
              loading={loading}
            />
          </div>
          <hr className="m-0 border-border-primary border-solid" />
          <div className="px-4 py-2">
            <CustomCheckbox
              checked={settings.sms}
              onChange={() => handleSettingChange('sms')}
              disabled={false}
              label="SMS"
              loading={loading}
            />
          </div>
          <hr className="m-0 border-border-primary border-solid" />
          <div className=" px-4 py-2">
            <CustomCheckbox
              checked={settings.whatsapp}
              onChange={() => handleSettingChange('whatsapp')}
              disabled={false}
              label="WhatsApp"
              loading={loading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationSettings;
